const normalizeChildren = (category) =>
  Array.isArray(category?.children) ? category.children : [];

export const findCategoryPath = (categories, targetId) => {
  if (!targetId) {
    return [];
  }

  for (const category of categories || []) {
    if (category?.Id === targetId) {
      return [category];
    }

    const childPath = findCategoryPath(normalizeChildren(category), targetId);
    if (childPath.length) {
      return [category, ...childPath];
    }
  }

  return [];
};

export const getChildCategories = (category) => normalizeChildren(category);

